<template lang='pug'>
.mainWrapper-innerContent
  .mainWrapper-leftContent
    BreadCrumb(:breadcrumbList='breadcrumbs' normal)
    .howto
      SectionTitle(sectionText='如何使用')
      HowToUseStep
      HowToUseDescription
  .mainWrapper-rightContent.show--bigScreens
    .sidebar--right
      StatisticsBlock(:title='data.statistics.title' :items='data.statistics.data' :subText='data.statistics.subText' type='today')
      LatestArticlesBlock(:title='data.latestArticles.title' type="latest" :params="params['latestArticleBlock']" :staticData='data.latestArticles')
</template>

<script>
import BreadCrumb from '@/components/modules/breadcrumb/breadcrumb.vue'
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import HowToUseStep from '@/components/how_to_use/how_to_use_step.vue'
import HowToUseDescription from '@/components/how_to_use/how_to_use_description.vue'
import StatisticsBlock from '@/components/statistics/statistics_block.vue'
import LatestArticlesBlock from '@/components/latest_articles/latest_articles_block.vue'


export default {
  components: {
    BreadCrumb,
    SectionTitle,
    HowToUseStep,
    HowToUseDescription,
    StatisticsBlock,
    LatestArticlesBlock
  },
  props: {
    data: Object,
    breadcrumbList: Array
  },
  data() {
    return {
      params: {
        "latestArticleBlock": {
          "size": 5,
          "sort": {
            "updatedAt": {
              "dir": "desc",
              "default": true
            }
          }
        }
      },
      breadcrumbs: JSON.parse(JSON.stringify(this.breadcrumbList))
    }
  },
  created() {
    this.breadcrumbs.push({
      text: '如何使用',
      link: '/how-to-use'
    })
  }
}
</script>
